"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ButtonUploadExcel = _interopRequireDefault(require("@/components/ButtonUploadExcel"));
var _SelectedGoods = _interopRequireDefault(require("../SelectedGoods/SelectedGoods.vue"));
var _validate = require("@/utils/validate");
var _paginationEffect = _interopRequireDefault(require("@/utils/paginationEffect"));
var couponEnum = _interopRequireWildcard(require("../../../../enum"));
var _common = require("../../../common");
var _api = _interopRequireWildcard(require("../../../api"));
var salesPromotionApi = _api;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ActivityAddorEdit',
  components: {
    ButtonUploadExcelVue: _ButtonUploadExcel.default,
    SelectGoodsVue: _SelectedGoods.default
  },
  data: function data() {
    return _objectSpread(_objectSpread({}, (0, _paginationEffect.default)(this.handlerGetListData)), {}, {
      couponRules: _common.couponRules,
      applicableProducts: [],
      tableData: [{
        a: 1
      }],
      showTableData: {
        list: [],
        total: 0
      },
      couponEnum: couponEnum,
      commonData: _common.commonData,
      timeFormat: _common.timeFormat,
      loading: false,
      loadingText: '提交中...',
      type: 'ADD',
      form: {
        distributionCustomers: [],
        cateIdList: []
      },
      TYPE_MAP: {
        1: 'FULL_AMOUNT_DISCOUNT',
        2: 'PER_FULL_AMOUNT_DISCOUNT',
        3: 'FULL_UNITS_DISCOUNT'
      }
    });
  },
  created: function created() {
    var id = this.$route.query.id;
    this.type = this.$route.path.split('/').pop();
    this.setTagsViewTitle(id);
    this.init();
    this.ID = id || null;
    if (!id) return;
    this.getDetail(id);
  },
  methods: {
    init: _common.init,
    setTagsViewTitle: function setTagsViewTitle(id) {
      var route = {
        path: this.$route.path,
        title: this.type == 'ADD' ? '促销活动添加' : this.type === 'EDIT' ? "\u7F16\u8F91\u4FC3\u9500\u6D3B\u52A8-".concat(id) : "\u590D\u5236\u4FC3\u9500\u6D3B\u52A8-".concat(id)
      };
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    close: function close() {
      this.form = {
        distributionCustomers: []
      };
      this.$router.push({
        path: '/marketing/salesPromotion/list'
      });
    },
    getDetail: function () {
      var _getDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.loadingText = '获取信息中...';
              this.loading = true;
              salesPromotionApi.detailActApi(id).then(function (res) {
                _this.handleInfo(res);
                _this.loading = false;
              }).catch(function (err) {
                _this.loading = false;
              });
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getDetail(_x) {
        return _getDetail.apply(this, arguments);
      }
      return getDetail;
    }(),
    handleInfo: function handleInfo() {
      var _distributionCustomer;
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = res || {},
        startTime = _ref.startTime,
        endTime = _ref.endTime,
        distributionCustomers = _ref.distributionCustomers,
        applicableRangeType = _ref.applicableRangeType,
        _ref$productAttrValue = _ref.productAttrValueList,
        productAttrValueList = _ref$productAttrValue === void 0 ? {} : _ref$productAttrValue,
        promotionDetail = _ref.promotionDetail;
      this.form = res;
      this.$set(this.form, 'receiveTime', startTime && endTime ? [startTime, endTime] : []);
      this.$set(this.form, 'distributionCustomers', distributionCustomers ? distributionCustomers === null || distributionCustomers === void 0 ? void 0 : (_distributionCustomer = distributionCustomers.split(',')) === null || _distributionCustomer === void 0 ? void 0 : _distributionCustomer.map(function (j) {
        return Number(j);
      }) : []);
      applicableRangeType !== 1 && this.updateTableData(productAttrValueList === null || productAttrValueList === void 0 ? void 0 : productAttrValueList.list); // 处理详情信息
      if (promotionDetail) {
        // 处理优惠详细信息
        try {
          var _ref2 = JSON.parse(promotionDetail) || {},
            discountTypeEnum = _ref2.discountTypeEnum,
            strategies = _ref2.strategies;
          var list = [];
          strategies.forEach(function (item, i) {
            var quantity = item.quantity,
              _item$benefit = item.benefit,
              benefit = _item$benefit === void 0 ? {} : _item$benefit;
            list.push({
              a: {
                'FULL_AMOUNT_DISCOUNT': 1,
                'PER_FULL_AMOUNT_DISCOUNT': 2,
                'FULL_UNITS_DISCOUNT': 3
              }[discountTypeEnum] || 1,
              discountValue: benefit === null || benefit === void 0 ? void 0 : benefit.amount,
              discount: quantity,
              b: benefit === null || benefit === void 0 ? void 0 : benefit.type
            });
          });
          this.tableData = list;
        } catch (error) {}
      }
    },
    updateTableData: function updateTableData() {
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.applicableProducts = _toConsumableArray(list);
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var start = (this.pageData.page - 1) * this.pageData.limit;
      var end = start + this.pageData.limit;
      this.showTableData.list = this.applicableProducts.slice(start, end);
      this.$set(this.showTableData, 'total', this.applicableProducts.length);
    },
    // 切换优惠方式
    changeRowA: function changeRowA() {
      var init = this.tableData[0];
      this.$set(init, 'b', init.a === 3 ? 1 : '');
      this.tableData = this.tableData.splice(0, 1);
    },
    // 切换优惠内容
    changeRowB: function changeRowB() {
      var _this2 = this;
      var init = this.tableData[0];
      this.tableData.forEach(function (j) {
        _this2.$set(j, 'b', init.b);
      });
    },
    changeRow: function changeRow(index) {
      if (_typeof(index) === 'object') {
        var _init = this.tableData[0];
        this.tableData.push({
          a: _init.a,
          b: _init.b
        });
      } else {
        this.tableData.splice(index, 1);
      }
    },
    goSelectGoods: function goSelectGoods() {
      this.$refs.selectGoodsVueRef.open({
        selectedList: this.applicableProducts,
        applicableRangeType: this.form.applicableRangeType
      });
    },
    changeApplicableRangeType: function changeApplicableRangeType() {
      this.applicableProducts = [];
      this.updateTableData();
    },
    removeGoods: function removeGoods(index) {
      this.applicableProducts.splice(index, 1);
      this.handlerGetListData();
    },
    //  请求工具函数
    request: function () {
      var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(api, params, callback) {
        var _this3 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              api(params).then(function (res) {
                callback(res);
                _this3.loading = false;
              }).catch(function (err) {
                _this3.loading = false;
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      function request(_x2, _x3, _x4) {
        return _request.apply(this, arguments);
      }
      return request;
    }(),
    getFileObject: function getFileObject(file) {
      console.log(file);
    },
    handleParams: function handleParams() {
      var _data$receiveTime, _data$receiveTime2, _data$distributionCus, _this$tableData, _this$tableData2;
      var data = _objectSpread({}, this.form);
      data.startTime = data === null || data === void 0 ? void 0 : (_data$receiveTime = data.receiveTime) === null || _data$receiveTime === void 0 ? void 0 : _data$receiveTime[0];
      data.endTime = data === null || data === void 0 ? void 0 : (_data$receiveTime2 = data.receiveTime) === null || _data$receiveTime2 === void 0 ? void 0 : _data$receiveTime2[1];
      data === null || data === void 0 ? true : delete data.receiveTime;
      // 商品信息
      if ([2, 3].includes(data.applicableRangeType)) {
        var _this$applicableProdu, _this$applicableProdu2;
        data.applicableProducts = (_this$applicableProdu = this.applicableProducts) === null || _this$applicableProdu === void 0 ? void 0 : (_this$applicableProdu2 = _this$applicableProdu.map(function (item) {
          return item.id;
        })) === null || _this$applicableProdu2 === void 0 ? void 0 : _this$applicableProdu2.join(',');
        data === null || data === void 0 ? true : delete data.cateIdList;
      } else if (data.applicableRangeType == 4) {
        // 展示分类
        data === null || data === void 0 ? true : delete data.applicableProducts;
      }
      ;
      data.distributionCustomers = data === null || data === void 0 ? void 0 : (_data$distributionCus = data.distributionCustomers) === null || _data$distributionCus === void 0 ? void 0 : _data$distributionCus.join(',');
      var _this$tableData$ = (_this$tableData = this.tableData) === null || _this$tableData === void 0 ? void 0 : _this$tableData[0],
        a = _this$tableData$.a;
      data.promotionDetail = {
        discountTypeEnum: this.TYPE_MAP[a],
        // 类型
        strategies: (_this$tableData2 = this.tableData) === null || _this$tableData2 === void 0 ? void 0 : _this$tableData2.map(function (item) {
          var _ref3 = item || {},
            discountValue = _ref3.discountValue,
            discount = _ref3.discount,
            b = _ref3.b;
          return {
            quantity: discount,
            benefit: {
              amount: discountValue,
              type: b || 1
            }
          };
        })
      };
      return data;
    },
    submitForm: (0, _validate.Debounce)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _this$tableData3,
        _this4 = this;
      var valid, lists, params;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return this.$refs.formRef.validate();
          case 1:
            valid = _context3.v;
            if (valid) {
              _context3.n = 2;
              break;
            }
            this.$message.warning('请填写完整信息');
            return _context3.a(2);
          case 2:
            lists = (_this$tableData3 = this.tableData) === null || _this$tableData3 === void 0 ? void 0 : _this$tableData3.filter(function (item) {
              var _ref5 = item || {},
                a = _ref5.a,
                discountValue = _ref5.discountValue,
                discount = _ref5.discount,
                b = _ref5.b;
              return a && discountValue && discount;
            });
            if (lists !== null && lists !== void 0 && lists.length) {
              _context3.n = 3;
              break;
            }
            this.$message.warning('请检查优惠详细配置是否填写完整！');
            return _context3.a(2);
          case 3:
            ;
            params = this.handleParams();
            console.log('params', params, this.tableData);
            this.loadingText = '提交中...';
            this.$alert('一旦操作成功,活动/功能将会生效并在前端露出,确认提交?', '提示', {
              showCancelButton: true,
              confirmButtonText: '确认提交',
              cancelButtonText: '取消',
              callback: function callback(action) {
                if (action === 'cancel') return;
                _this4.loading = true;
                if (_this4.type === 'COPY') {
                  delete params.id;
                }
                ;
                salesPromotionApi[_this4.type === 'EDIT' ? 'updateActApi' : 'createActsApi'](params).then(function (res) {
                  _this4.$closeCompletedView();
                  _this4.loading = false;
                  _this4.$emit('refresh');
                  _this4.close();
                  _this4.$message.success('添加成功！');
                });
              }
            });
          case 4:
            return _context3.a(2);
        }
      }, _callee3, this);
    })))
  }
};